import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, ModalControlTriggerProps, Text } from '@frontend/design-system';
import { EIVDashboardTrialWidgetTrackingIds } from '../../../../../constants/tracking-ids';

type OnboardingItemType = 'ConnectPayers' | 'FavoriteCDTCodes' | 'SetUpDeltaDentalMFA';

type OnboardingItemProps = {
  title: string;
  itemType: OnboardingItemType;
  isOnboardingCompleted: boolean;
  triggerProps: ModalControlTriggerProps;
  icon?: React.ReactNode;
};

const trackingIDMap: Record<OnboardingItemType, string> = {
  ConnectPayers: EIVDashboardTrialWidgetTrackingIds.setupConnectPayersAction,
  FavoriteCDTCodes: EIVDashboardTrialWidgetTrackingIds.setupFavoriteCDTCodesAction,
  SetUpDeltaDentalMFA: EIVDashboardTrialWidgetTrackingIds.setupMFAAction,
};

export const OnboardingItem = ({ title, isOnboardingCompleted, itemType, icon, triggerProps }: OnboardingItemProps) => {
  const { t } = useTranslation('featurePromotion', { keyPrefix: 'weave-insurance-eligibility' });
  return (
    <div css={onBoardingItemStyles}>
      <div css={onBoardingItemContentStyles}>
        {icon && icon}
        <Text weight='bold' size='medium'>
          {title}
        </Text>
      </div>
      {isOnboardingCompleted ? (
        <Icon name='success' size={16} color='success' />
      ) : (
        <Button variant='tertiary' {...triggerProps} trackingId={trackingIDMap[itemType]}>
          {t('Setup')}
        </Button>
      )}
    </div>
  );
};

const onBoardingItemStyles = css({
  display: 'flex',
  height: theme.spacing(6.5),
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  border: '2px',
  borderRadius: theme.borderRadius.small,
  boxShadow: theme.shadows.light,
  backdropFilter: 'blur(4px)',
  '@media (max-width: 900px)': {
    flex: 'unset',
    width: '100%',
  },
});

const onBoardingItemContentStyles = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.5),
});
